import { ImageCheck, LinkWrapper } from "Explore/Components";
import { ImageCheckType, ImageType } from "Explore/Config/ImageType";
import styles from "./UnitCardList.module.scss";
import classNames from "classnames";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Button, Grid } from "@mui/material";
import UnitCardBasicInfo from "./BasicInfo";
import useDeviceCheck from "Hooks/useDeviceCheck";
import FavoriteButton from "../FavoriteButton";

const UnitCardList = ({
  data: _data,
  className = "",
  simpleMode,
  onKeywordClick,
  hideActions,
}) => {
  const { isMobile } = useDeviceCheck();
  const data = {
    ..._data,
    name: _data.name || _data.unit_name,
    id: _data.id || _data.unit_id,
  };
  const statistics = [
    {
      icon: IconPack.unit_faculty_members,
      value: data.total_faculties,
      title: "Indexed faculty members",
    },
    {
      icon: IconPack.citation,
      value: data.total_citation,
      title: "Citations",
    },
    {
      icon: IconPack.publications,
      value: data.total_publication,
      title: "Publications",
    },
    {
      icon: IconPack.h_index,
      value: data.total_h_index,
      title: "H-index",
    },
    {
      icon: IconPack.seniority,
      value: data.average_seniority,
      title: "Average academic age",
    },
  ].filter((e) => !!e.value);

  const renderLogo = () => {
    return (
      <ImageCheck
        url={`https://media.academic.online/institutions_images/${data.institution_id}/${ImageType.SEAL}.png`}
        className={styles["avatar"]}
        alt={"avatar"}
        type={ImageCheckType.INSTITUTION_LOGO}
      />
    );
  };

  return (
    // <Badge.Ribbon
    //   text={data.level ? `${data.level}` : null}
    //   color={level_colors[data.level]}
    //   className={classNames(styles["unit-card-list-badge"], {
    //     [styles["no-level"]]: !data.level,
    //   })}
    // >
    <div className={classNames(styles["unit-card-list"], className)}>
      <div className={styles["unit-card-list__top"]}>
        {renderLogo()}
        <div className={styles["unit-name--wrapper"]}>
          {/* {isMobile && renderLogo()} */}
          <LinkWrapper
            className={styles["unit-name--wrapper--link"]}
            link={`/explore/unit/${data.explore_slug || data.id}`}
            component={
              <p className={classNames(styles["unit-name"], styles["link"])}>
                {data.name}
              </p>
            }
          />
          {!hideActions && (
            <div className={styles["entity-actions"]}>
              <FavoriteButton
                isFavorited={data.is_favorited}
                itemId={data.id}
                itemType="unit"
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles["unit-card-list__body"]}>
        <div className={styles["unit-card-list__body__left"]}>
          {(!!data.institution_name || !!data.institution.name) && (
            <div className={styles["unit-card-list__body--item"]}>
              <p className={styles["unit-card-list__body--item--title"]}>
                Institution
              </p>
              <LinkWrapper
                link={`/explore/institution/${data.institution_explore_slug || data.institution?.explore_slug || data.institution_id || data.institution?.id
                  }`}
                component={
                  <p
                    className={classNames(
                      styles["unit-card-list__body--item--value"],
                      styles["link"]
                    )}
                  >
                    {data.institution_name || data.institution.name}
                  </p>
                }
              />
            </div>
          )}
          {!!data.level && (
            <div className={styles["unit-card-list__body--item"]}>
              <p className={styles["unit-card-list__body--item--title"]}>
                Level
              </p>
              <p className={styles["unit-card-list__body--item--value"]}>
                {data.level}
              </p>
            </div>
          )}
        </div>

        {/* <div className={styles["unit-card-list__body__right"]}>
          <Grid container className={styles["statistics"]} spacing="24px">
            {statistics.map((e, i) => (
              <Grid
                item
                xs={(!isMobile && statistics.length) > 4 ? 4 : 6}
                className={styles["statistic"]}
                key={i}
              >
                {e.icon}
                <div className={styles["unit-card-list__body--item"]}>
                  <p className={styles["unit-card-list__body--item--title"]}>
                    {e.title}
                  </p>
                  <p className={styles["unit-card-list__body--item--value"]}>
                    {numberRegex(e.value)}
                  </p>
                </div>
              </Grid>
            ))}
          </Grid>
        </div> */}
      </div>

      <div className={styles["unit-card-list__bottom"]}>
        {data?.keywords?.length > 0 && (
          <div className={styles["keywords"]}>
            {!simpleMode && <span>Noticable Interests: </span>}
            {data.keywords.map((item, index) => {
              return onKeywordClick ? (
                <Button
                  size="small"
                  key={index}
                  className={classNames(
                    styles["keywords--item"],
                    styles["clickable"]
                  )}
                  variant="contained"
                  onClick={() => onKeywordClick(item.value)}
                >
                  {item.rank && <b>#{item.rank}&nbsp;</b>}
                  {item.value}
                </Button>
              ) : (
                <div className={styles["keywords--item"]} key={index}>
                  {item.rank && <b>#{item.rank}&nbsp;</b>}
                  {item.value}
                </div>
              );
            })}
          </div>
        )}
        {!simpleMode && <UnitCardBasicInfo id={data.id} />}
      </div>
    </div>
    // </Badge.Ribbon>
  );
};

export default UnitCardList;
